import * as Amplitude from 'amplitude-js/amplitude';
import { environment } from 'environments/environment';
var AmplitudeService = /** @class */ (function () {
    function AmplitudeService() {
        this.amplitude = Amplitude.getInstance();
        this.amplitude.init(environment.AMPLITUDE_API_KEY);
    }
    AmplitudeService.prototype.logEvent = function () {
        var event = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            event[_i] = arguments[_i];
        }
        var _a;
        (_a = this.amplitude).logEvent.apply(_a, event);
    };
    AmplitudeService.prototype.setUserProperties = function (userProperties) {
        this.amplitude.setUserProperties(userProperties);
    };
    AmplitudeService.prototype.setUserId = function (userId) {
        this.amplitude.setUserId(userId);
    };
    AmplitudeService.prototype.setUser = function (user) {
        this.setUserId(user.username);
        this.setUserProperties({
            account: user.domain,
            name: user.name,
            surname: user.surname,
            companyName: user.companyName,
            role: user.role
        });
    };
    return AmplitudeService;
}());
export { AmplitudeService };
